import React, {useCallback, useEffect} from 'react';
import {tableStore, gamesStore} from 'app/store/global';
import {inject, observer} from 'mobx-react';
import {NavLink, useLocation} from 'react-router-dom';
import I18n from 'app/i18n';
import {isDesktop, isGuest} from 'app/utils';
import {countedTitle} from 'app/utils/countedTitle';
import {scrollToBottomStream} from '../streams/stream_functions';
import {IncubatorStore} from 'app/store/IncubatorStore';
import {TableStore} from 'app/store/TableStore';
import {isBetPage} from 'app/utils/IsBetPage';
import {getClassNameActiveLink, getTableLinkPath} from 'app/utils/link_helper';
import {isAdmin} from 'app/utils/IsAdmin';
import {useOutlet, useParams} from 'react-router';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';
import {openAuth} from 'app/components/auth/auth';
import {goToLinkMySimpleBets} from 'app/utils/app_links';
import {StreamsPlayPage} from 'app/components/streams';

interface PlayPageWrapperInterface {
    params?: {
        filter?: string
    },
    tableStore?: TableStore,
    incubatorStore?: IncubatorStore
    children?: React.ReactNode
}

const PlayPageWrapper = (props: PlayPageWrapperInterface): React.JSX.Element => {
    const outlet = useOutlet();
    const {filter} = useParams();
    const location = useLocation();

    const getCurrentTabTitle = (): string => {
        const {pathname} = location;

        switch (true) {
        case pathname.includes('/play/incubator'):
            return I18n.t('incubator');
        case pathname.includes('/play/results'):
            return I18n.t('results');
        case pathname.includes('/play/bets'):
            return I18n.t('user_menu_table');
        case pathname.includes('/play/quick_bets'):
            return I18n.t('quick_bets');
        default:
            return I18n.t('user_menu_table');
        }
    };

    useEffect(() => {
        if (filter) {
            const [game] = gamesStore.collection.filter(g => g.slug === filter);
            tableStore.clearFilters();
            tableStore.applyTableFilter(game && game.id,
                null,
                {forceUseHidden: true, needUpdateUrl: true, results: tableStore.results});
        }

        scrollToBottomStream();
        updateSportsInStores();
    }, [filter, props]);

    const updateSportsInStores = () => {
        const {incubatorStore} = props;

        tableStore.updateFiltersPage();
        incubatorStore.updateFiltersPage();
    };

    const {incubatorCount} = props.tableStore;
    const isShowTabsDesktopMobile = isDesktop() || !isDesktop() && isBetPage(true);

    const myBetsButtonHandler = useCallback(() => {
        if (isGuest()) {
            openAuth('/my_bets');
        } else {
            goToLinkMySimpleBets();
        }
    }, []);

    return <StreamsPlayPage>
        <div className="tabs js-tabs tabs--top">
            {isShowTabsDesktopMobile && <div className="tabs__header__wrapper">
                <div className="tabs__header">
                    <div className="tabs__inner__header tabs-play">
                        <NavLink
                            to={getTableLinkPath('/play/bets')}
                            className={getClassNameActiveLink}>
                            {I18n.t('user_menu_table')}
                        </NavLink>
                        {isAdmin() && <NavLink
                            to={getTableLinkPath('/play/quick_bets')}
                            className={getClassNameActiveLink}>
                            {I18n.t('quick_bets')}
                        </NavLink>}
                        <NavLink
                            to={getTableLinkPath('/play/incubator/all')}
                            className={getClassNameActiveLink}>
                            {countedTitle(I18n.t('incubator'), incubatorCount)}
                        </NavLink>
                        {<NavLink
                            to={getTableLinkPath('/play/results')}
                            className={getClassNameActiveLink}>
                            {I18n.t('results')}
                        </NavLink>}
                    </div>
                </div>
                {!isDesktop() && <button
                    className="button-my-bets"
                    onClick={myBetsButtonHandler}
                    title={I18n.t('user.rates')}
                >
                    <SpriteIcon name="#svg-bets" className="svg-default"/>
                </button>}
            </div>}
            <h1 className="visually-hidden-title">{getCurrentTabTitle()}</h1>
            {outlet}
        </div>
    </StreamsPlayPage>;
};
export default inject('tableStore', 'incubatorStore')(observer(PlayPageWrapper));
